import "./AddDevice.scss";
import Spinner from "../../../components/Spinner/Spinner";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import useAddDevice from "./useAddDevice";
import AddDeviceHeader from "./AddDeviceHeader";
import AddDeviceTable from "./AddDeviceTable";
import AddDeviceFormModal from "./AddDeviceFormModal";
import DeviceJsonUploadModal from "./DeviceJsonUploadModal";

export default function AddDevice() {
  const {
    rows,
    page,
    rowsPerPage,
    isLoading,
    isSubmitting,
    deleteDialog,
    reassignDialog,
    confirmReassignment,
    cancelReassignment,
    addForm,
    errors,
    createMode,
    setCreateMode,
    jsonFile,
    jsonFileError,
    handleJsonFileSelected,
    totalRows,
    fetchError,
    searchQuery,
    addOrEditDevice,
    isEditing,
    healthProfessionalData,
    openAddModal,
    openEditModal,
    closeAddEditModal,
    handleChange,
    handleSubmit,
    retryFetchDevices,
    handleDelete,
    confirmDelete,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSearchChange,
    uploadJsonDialog,
    handleUploadJson,
    handleViewDevice,
  } = useAddDevice();

  return (
    <div className="mainadd">
      {isSubmitting && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      <AddDeviceHeader
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        onAddDevice={openAddModal}
      />
      <AddDeviceTable
        rows={rows}
        isLoading={isLoading}
        fetchError={fetchError}
        onRetry={retryFetchDevices}
        onEdit={openEditModal}
        onDelete={handleDelete}
        onUploadJson={handleUploadJson}
        onViewDevice={handleViewDevice}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {deleteDialog.open && (
        <ConfirmDialog
          open={deleteDialog.open}
          onClose={deleteDialog.closeDialog}
          title="Delete Device"
          severity="error"
          confirmText="DELETE"
          content={
            deleteDialog.target?.healthProfessionalName ? (
              <span>
                This device is currently assigned to <strong>{deleteDialog.target.healthProfessionalName}</strong>. Deleting it will unassign it. Are you sure you want to delete this device?
              </span>
            ) : (
              <span>
                Are you sure you want to delete device <strong>{deleteDialog.target?.deviceName || "this Device"}</strong>?
              </span>
            )
          }
          buttonText="Yes, Delete"
          additionalButtonText="Cancel"
          onButtonClick={confirmDelete}
          onAdditionalButtonClick={deleteDialog.closeDialog}
        />
      )}

      {reassignDialog.open && (
        <ConfirmDialog
          open={reassignDialog.open}
          onClose={cancelReassignment}
          title="Reassign Device"
          severity="warning"
          content={
            <span>
              This device is currently assigned to active patients. Reassigning this device will remove it from the current Health Professional and active patients. Do you want to continue?
            </span>
          }
          buttonText="Confirm"
          additionalButtonText="Cancel"
          onButtonClick={confirmReassignment}
          onAdditionalButtonClick={cancelReassignment}
        />
      )}

      <AddDeviceFormModal
        open={addOrEditDevice}
        onClose={closeAddEditModal}
        isEditing={isEditing}
        addForm={addForm}
        errors={errors}
        onChange={handleChange}
        onSubmit={handleSubmit}
        healthProfessionalData={healthProfessionalData}
        createMode={createMode}
        onCreateModeChange={setCreateMode}
        jsonFile={jsonFile}
        jsonFileError={jsonFileError}
        onJsonFileSelected={handleJsonFileSelected}
      />

      <DeviceJsonUploadModal
        open={uploadJsonDialog.open}
        onClose={uploadJsonDialog.closeDialog}
        device={uploadJsonDialog.target}
        onUploaded={uploadJsonDialog.closeDialog}
      />
    </div>
  );
}
